import { getPermissionState, subscribePermission } from 'utils/browserPermissions';

const LNA_PERMISSION_NAMES = ['local-network', 'local-network-access'];

// Private IPv4 ranges + loopback: 10/8, 127/8, 192.168/16, 172.16/12.
const PRIVATE_IPV4 = /^(10\.|127\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/;

// Resolves to 'granted' | 'prompt' | 'denied' | 'unknown'.
export const getLocalNetworkAccessState = () => getPermissionState(LNA_PERMISSION_NAMES);

export const subscribeLocalNetworkAccess = (callback) => subscribePermission(LNA_PERMISSION_NAMES, callback);

export function isLocalNetworkUrl(wsUri) {
    if (!wsUri) return false;
    let hostname;
    try {
        hostname = new URL(wsUri).hostname;
    } catch {
        return false;
    }
    if (!hostname) return false;

    const host = hostname.replace(/^\[|\]$/g, '').toLowerCase(); // strip IPv6 brackets
    if (host === 'localhost' || host === '::1' || host.endsWith('.local') || host.endsWith('.localhost')) return true;
    return PRIVATE_IPV4.test(host);
}
